import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './SectionDivider.scss';

const SectionDivider = (props) => {
    return (
        <div className={classnames('section-divider', {
                            [(props.classNames || '')]: props.classNames
                        })} >
            <div className="section-divider-line" />
        </div>
    )
}

SectionDivider.propTypes = {
    classNames: PropTypes.string,
}

export default SectionDivider;